import { render, staticRenderFns } from "./CartSummary.vue?vue&type=template&id=515d10f6&scoped=true&"
import script from "./CartSummary.vue?vue&type=script&lang=js&"
export * from "./CartSummary.vue?vue&type=script&lang=js&"
import style0 from "../../styles/cart-summary.css?vue&type=style&index=0&id=515d10f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d10f6",
  null
  
)

export default component.exports